import { gql } from "@apollo/client";
import { DEFAULT_USER_SETTINGS, UserId, UserSettings } from "@hex/common";

import { useGetUserForSettingsQuery } from "./useUserForSettings.generated";

gql`
  query GetUserForSettings {
    me {
      id
      magicAutoRunOnKeep
      vimMode
      userSettings
    }
  }
`;

export function useUserForSettings(): {
  vimMode: boolean;
  userSettings: UserSettings;
  id: UserId | undefined;
} {
  const { data } = useGetUserForSettingsQuery();

  const userSettings = data?.me?.userSettings ?? {};
  return {
    vimMode: data?.me?.vimMode ?? false,
    userSettings: { ...DEFAULT_USER_SETTINGS, ...userSettings },
    id: data?.me?.id,
  };
}
